"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "APPLY_COUPON_PAGE_DEFAULTS", {
  enumerable: true,
  get: function () {
    return _ApplyCouponPage.APPLY_COUPON_PAGE_DEFAULTS;
  }
});
Object.defineProperty(exports, "ApplyCouponPage", {
  enumerable: true,
  get: function () {
    return _ApplyCouponPage.default;
  }
});
Object.defineProperty(exports, "getCouponDiscountLabel", {
  enumerable: true,
  get: function () {
    return _ApplyCouponPage.getCouponDiscountLabel;
  }
});
var _ApplyCouponPage = _interopRequireWildcard(require("./ApplyCouponPage"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }